var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"wrapper"},[_c('i',{staticClass:"iconfont icon-jiazai"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }